import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from '../../api/api';

export const commentApi = createApi({
  reducerPath: 'commentApi',
  baseQuery: axiosBaseQuery(),
  tagTypes: ['Comment'],
  endpoints: (builder) => ({
    getComments: builder.query({
      query: (page = 1) => ({
        url: 'api/web/v1/site/comment',
        method: 'GET',
        params: { page },
        tokenType: 'admin',
      }),
      providesTags: ['Comment'],
    }),
    addComment: builder.mutation({
      query: (formData) => ({
        url: 'api/web/v1/site/add-comment',
        method: 'POST',
        data: formData,
        isFormData: true,
        tokenType: 'admin',
      }),
      invalidatesTags: ['Comment'],
    }),
    updateComment: builder.mutation({
      query: (formData) => ({
        url: 'api/web/v1/site/update-comment',
        method: 'POST',
        data: formData,
        isFormData: true,
        tokenType: 'admin',
      }),
      invalidatesTags: ['Comment'],
    }),
    deleteComment: builder.mutation({
      query: (formData) => ({
        url: 'api/web/v1/site/delete-comment',
        method: 'POST',
        data: formData,
        isFormData: true,
        tokenType: 'admin',
      }),
      invalidatesTags: ['Comment'],
    }),
  }),
});

export const {
  useGetCommentsQuery,
  useAddCommentMutation,
  useUpdateCommentMutation,
  useDeleteCommentMutation,
} = commentApi;
